import styled from 'styled-components';
import { Container, Col } from 'react-bootstrap';
import searchSiteImage from '../../../images/topMobile-nav-search.png';
import navBarImage from '../../../images/topMobile-nav-nav.png';

export const MainContainer = styled(Container)`
  position: relative;
  display: block;
  width: 100%;
  padding: 25px 25px 47px 20px;
  border-top: 8px solid #083a81;
  background-size: 1px auto;
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  letter-spacing: 0.02em;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  @media print {
    display: none;
  }
`;
export const TopLogoAnchor = styled.a`
  text-align: center;
  text-decoration: none;
`;
export const TopLogo = styled.img`
  width: 270px;
  height: auto;
  border: 0;
  vertical-align: top;
  @media print {
    display: none;
  }
`;

export const TopNav = styled.div`
  float: none;
  width: 80px;
  margin: 20px auto 0 auto;
`;

export const NavMenu = styled.a`
  display: block;
  float: right;
  width: 36px;
  height: 36px;
  background: url(${navBarImage}) no-repeat 0 0;
  background-size: 36px auto;
  cursor: pointer;
  &.active {
    background-position: 0 -36px;
  }
`;

export const NavSearchSite = styled(NavMenu)`
  background: url(${searchSiteImage}) no-repeat 0 0;
  background-size: 36px auto;
  cursor: pointer;
`;

export const DropDownContainer = styled.div`
  position: absolute;
  color: #fff;
  text-align: left;
  width: 100%;
  z-index: 999;
  background: #0397d6;
`;

export const HeaderMenu = styled.a`
  display: block;
  padding: 10px 10px 10px 10px;
  text-align: left;
  text-decoration: none;
  font-size: 20px;
  font-family: 'Gotham-Book', arial, sans-serif;
  letter-spacing: 0.02em;
  line-height: 22px;
  color: #fff !important;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background: #0397d6;
`;

export const SubHeaderMenu = styled(HeaderMenu)`
  padding: 10px 10px 10px 30px;
  font-size: 18px;
  line-height: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background: #0069aa;
`;

export const ArrowImageContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 43px;
  height: 43px;
  padding: 17px 0 0 10px;
  cursor: pointer;
`;

export const ArrowImage = styled.img`
  height: 12px;
  width: auto;
  border: 0;
  vertical-align: top;
`;

export const RelativeCol = styled(Col)`
  position: relative;
`;

export const SubHeaderMenuLast = styled(HeaderMenu)`
  padding: 10px 10px 10px 50px;
  font-size: 16px;
  line-height: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background: #0397d6;
`;
